export default "__VITE_ASSET__DB3SEJ3a__"